import React from "react";
class ShipingMethod extends React.Component {

  goBack = event => {
    event.preventDefault();
    this.props.back();
  };

  handleShipping = event => {
    event.preventDefault();
    this.props.handleShippingMethod();
  };
  render() {
    console.log("check shipping method", this.props);
    return (
      <div className="col-lg-7 offset-lg-5 services_clip bg-gradient text-white">
        <div className="services_bg_pad">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <div className="text-center services_boxes mt-3 rounded p-4">
                <div className="services_content mt-3">
                  <h2 className="mb-0">SHIPPING METHOD</h2>

                  <div style={{ clear: "both", height: "15px" }} />
                  <p className="mb-0 mt-2">
                    <input type="radio" name="easyreturn" defaultChecked /> US
                    Postal Service Priority Mail with Tracking and Insurance
                  </p>

                  <div style={{ clear: "both", height: "30px" }} />

                  <a
                      href="javascript:void(0)"
                      onClick={this.goBack}
                      className="btn btn-outline-white"
                  >
                    Back
                  </a>

                  <a
                      style={{marginLeft:"10%"}}
                    href="javascript:void(0)"
                    onClick={this.handleShipping}
                    className="btn btn-outline-white"
                  >
                    CONTINUE
                  </a>

                  <div style={{ clear: "both", height: "450px" }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ShipingMethod;



// WEBPACK FOOTER //
// ./src/pages/rechargeCheckout/ShipingMethod.js